module.exports = "/assets/data/61eeff4385d049763d667818b7ccf0f7-DT2.data.json";